import axios from 'axios';

const api = axios.create({
    //baseURL: 'https://services.dommusbeta.com.br/vendaonline'
    baseURL: 'https://services.dommus2.com.br/vendaonline'
})

export default api